import { FC } from "react";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "theme";
import { GlobalStyle } from "theme/GlobalStyles";
import { ApolloProvider } from "@apollo/client";
import { apolloClient } from "setup/apollo";
import { UserContextProvider } from "contexts/UserContext";
import { VenueContextProvider } from "contexts/VenueContext";
import BfCacheClearfix from "components/common/BfCacheClearfix";

import IntlProvider from "./IntlProvider";
import AntdProvider from "./AntdProvider";
import RouterProvider from "./RouterProvider";

const AppProvider: FC = () => (
  <ApolloProvider client={apolloClient}>
    <BfCacheClearfix />
    <ThemeProvider theme={defaultTheme}>
      <GlobalStyle />
      <IntlProvider>
        <AntdProvider>
          <VenueContextProvider>
            <UserContextProvider>
              {({ isInitializing }) => !isInitializing && <RouterProvider />}
            </UserContextProvider>
          </VenueContextProvider>
        </AntdProvider>
      </IntlProvider>
    </ThemeProvider>
  </ApolloProvider>
);

export default AppProvider;
